import template from './project-mapping.html';
import controller from './project-mapping.controller';

let projectMappingComponent = {
  restrict: 'E',
  template,
  controller
};

export default projectMappingComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/project-mapping/project-mapping.component.js